'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ./~/@kyleshockey/js-yaml/index.js
// module id = 368
// module chunks = 0